import formieRequestCallback from '../helpers/formie-request-callback'
import { useSiteInfo } from 'shared'

export const useFormieRequestCallback = () => {
  const siteInfo = useSiteInfo()

  return formieRequestCallback(siteInfo)
}
